
export const epochToDate = (utcSeconds) => {
    return new Date(utcSeconds * 1000).toDateString();
}
